import React, { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { User, Workout } from "../../../constants/types";

// Chart.js and react-chartjs-2
import { Chart as ChartJS, registerables } from "chart.js";
import ChartsTabsView from "./charts-tabs-view";
import TablesTabsView from "./tables-tabs-view";
ChartJS.register(...registerables);

// Drawer width
const drawerWidth = 240;

export default function AdminLoggedIn() {
  const userData = useSelector((state: RootState) => state.data.user);
  const [drawerOpen, setDrawerOpen] = useState(true);
  const [view, setView] = useState<"charts" | "tables">("charts");

  if (!userData) {
    return <div>Loading...</div>;
  }

  // Pull out the arrays you need
  const { user: users, workouts } = userData;

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      <CssBaseline />

      {/* Top AppBar with Menu button */}
      <AppBar
        sx={{
          marginTop: 128,
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={() => setDrawerOpen(!drawerOpen)}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            Admin Dashboard
          </Typography>
        </Toolbar>
      </AppBar>

      <Toolbar />

      {/* Main Content Area */}
      <Box
        component="main"
        // Key change: use margin: "36px" to get 36 px on all sides
        sx={{
          flexGrow: 1,
          margin: "36px",
          justifyContent: "center",
          // Keep this Toolbar if you want extra spacing under the fixed AppBar:
          // it pushes content below the AppBar's height.
        }}
      >
        <Toolbar />

        {view === "charts" ? (
          <ChartsTabsView users={users} workouts={workouts} />
        ) : (
          <TablesTabsView users={users} workouts={workouts} />
        )}
      </Box>
    </Box>
  );
}
